import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-apps-banner',
    templateUrl: './apps-banner.component.html',
    styleUrls: ['./apps-banner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppsBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
